import React from 'react';
import { differentiators } from '../data/content';
export function Differentiators() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-31" data-mp="1mcov2wbletnh">
      <div className="mx-auto max-w-2xl text-center" data-id="element-32" data-mp="1mb3xextzeule">
        <h2 className="text-[1.1rem] font-extrabold uppercase leading-tight text-navy sm:text-[1.7rem]" data-id="element-33" data-mp="1r3ncy0c8bzsu">
          This isn't just another ultrasound ebook
        </h2>
        <p className="mt-0.5 text-[0.74rem] font-extrabold uppercase tracking-wide text-gold sm:text-[0.9rem]" data-id="element-34" data-mp="zcr0h0u2zx63">
          It's a ready-to-use visual study system.
        </p>
        <div className="mt-2 grid gap-1.5 text-left sm:grid-cols-2" data-id="element-35" data-mp="13gf6hf32ekp8">
          {differentiators.map(item => <div key={item.title} className="rounded-md border border-navy/10 bg-clinical px-2.5 py-2" data-id="element-36" data-mp="1dcihzbjt3vou">
              <h3 className="font-body text-[0.76rem] font-extrabold text-navy sm:text-[0.88rem]" data-id="element-37" data-mp="2jrj7ayebtfmg">
                <span aria-hidden="true" data-id="element-38" data-mp="2oqm7a4fg8vnk">{item.icon}</span> {item.title}
              </h3>
              <p className="mt-0.5 text-[0.74rem] leading-[1.35] sm:text-[0.86rem]" data-id="element-39" data-mp="bnst7jjrpsht">
                {item.body}
              </p>
            </div>)}
        </div>
        <p className="mt-2 text-[0.72rem] font-extrabold uppercase tracking-wide text-sono sm:text-[0.86rem]" data-id="element-40" data-mp="2nw095qci7gy">
          Less searching. Less confusion. More visual clarity.
        </p>
      </div>
    </section>;
}